import { put, call } from 'redux-saga/effects';
import { SettingAction, UIAction } from '../actions';
import { SettingService } from '../services';
import { generateReadableError } from 'hooks';

export function* saveSetting(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(SettingAction.saveSettingSuccess(null));
  try {
    let response = null;
    if (action.payload.data_key === 'ENRICHMENT_SERVICE') {
      response = yield call(SettingService.getInstance().changeEnrichmentSetting, action.payload);
    }
    else {
      response = yield call(SettingService.getInstance().saveSetting, action.payload);
    }
    const { data } = response;

    yield put(SettingAction.saveSettingSuccess(data));
    yield put(UIAction.showLoading(false));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }

}



export function* getSetting(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(SettingAction.getSettingSuccess(null));
  try {
    let response = null;
    if (action.payload.data_key === 'ENRICHMENT_SERVICE') {
      response = yield call(SettingService.getInstance().viewEnrichmentSetting, action.payload);
    }
    else {
      response = yield call(SettingService.getInstance().fetchSetting, action.payload);
    }
    const { data } = response;
    yield put(SettingAction.getSettingSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* saveAppVersion(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(SettingAction.saveAppVersionSuccess(null));
  try {
    const { data } = yield call(SettingService.getInstance().saveAppVersion, action.payload);
    yield put(SettingAction.saveAppVersionSuccess(data));
    yield put(UIAction.showLoading(false));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getAppVersion(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(SettingAction.getAppVersionSuccess(null));
  try {
    const { data } = yield call(SettingService.getInstance().getAppVersion, action.payload);
    yield put(SettingAction.getAppVersionSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}







